// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ClaimCustomerDetails = t.struct({
    city: t.String,
    customer: t.String,
    email: t.String,
    firstName: t.String,
    lastName: t.String,
    phoneNumber: t.String,
    postalCode: t.String,
    region: t.String,
    street: t.String
}, {
    name: 'ClaimCustomerDetails',
    strict: true
});

export const getDefaultState = () => new ClaimCustomerDetails({
    city: '',
    customer: '',
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    postalCode: '',
    region: '',
    street: ''
});

export default ClaimCustomerDetails;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-customer-details.js